import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
export const supportedLanguages = ["en", "uk", "ru", "es"];
const fallbackLocale = "en";

const LOCALE_STORAGE_KEY = "eg_locale";

function getBrowserLocale() {
  const lang = navigator.language || navigator.userLanguage;
  return lang ? lang.split("-")[0] : "en";
}

function resolveDefaultLocale() {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && supportedLanguages.includes(stored)) return stored;
  const browser = getBrowserLocale();
  return supportedLanguages.includes(browser) ? browser : fallbackLocale;
}

const defaultLocale = resolveDefaultLocale();

function loadLocaleMessages() {
  const context = require.context("../locales/", true, /\.json$/);
  const messages = {};

  context.keys().forEach((key) => {
    const parts = key.replace("./", "").split("/");
    const locale = parts[0];

    const fileMessages = context(key);

    if (!messages[locale]) {
      messages[locale] = {};
    }

    Object.assign(messages[locale], fileMessages);
  });

  return messages;
}

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale,
  messages: process.env.NODE_ENV === "production" ? {} : loadLocaleMessages(),
});

export default i18n;
